import { render, staticRenderFns } from "./OperationSelectMajor.vue?vue&type=template&id=24960c69&"
import script from "./OperationSelectMajor.vue?vue&type=script&lang=js&"
export * from "./OperationSelectMajor.vue?vue&type=script&lang=js&"
import style0 from "./OperationSelectMajor.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports